import { Box, Button, Grid, TextField, Typography } from "@mui/material";
import jwt_decode from "jwt-decode";
import { useEffect, useRef, useState } from "react";
import { NavigateFunction, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import { getAppRoutes } from "../../Global";
import HBLogo from "../../images/hardbit_feher.png";
import MicraLogo from "../../images/micra.png";
import Q92 from "../../images/Q92.png";
import ResponseModel from "../../models/ResponseModel";
import LoginService from "../../services/login/LoginService";

import { LoginPageStyles } from "./LoginPage.style";

type LoginPageProps = {
  loggedInState: boolean;
  setLoggedInUser: React.Dispatch<React.SetStateAction<string>>;
  setLoggedInState: React.Dispatch<React.SetStateAction<boolean>>;
};

// -----------------------------------------------------------------Exports---
const LoginPage = (props: LoginPageProps): JSX.Element => {
  const navigate: NavigateFunction = useNavigate();
  const [username, setUserName] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const passwordRef = useRef<HTMLInputElement | null>(null);

  //go home if logged in
  useEffect((): void => {
    if (props.loggedInState) {
      navigate(getAppRoutes.home);
    }
  }, []);

  //handle login event
  const handleSubmit = async (): Promise<void> => {
    const response: ResponseModel = await LoginService.onLogin(username.toUpperCase(), password);

    if (response.status === 200) {
      const loginData: { token?: string } = (response.data ?? {}) as { token?: string };
      const token: string = loginData.token ?? "";
      localStorage.setItem("micra_token", "Bearer " + token);
      props.setLoggedInState(true);
      const decoded: { sub?: string } = jwt_decode<{ sub?: string }>(token);
      props.setLoggedInUser(decoded.sub ?? "");
    } else {
      toast.error("Sikertelen bejelentkezés");
    }
  };

  // --------------------------------------------------------------Return---
  return (
    <Box style={LoginPageStyles.box}>
      <Box style={LoginPageStyles.headerBox}>
        <img src={MicraLogo} alt="Cég logó" style={LoginPageStyles.headerImage} />
        <Typography style={LoginPageStyles.headerText}>Terminál</Typography>
        <img src={HBLogo} alt="Fejlesztő logó" style={LoginPageStyles.headerImage} />
      </Box>
      <Box style={LoginPageStyles.contentBox}>
        <Grid container>
          <Grid item sm={6} xs={12} style={LoginPageStyles.formGrid}>
            <TextField
              autoFocus
              variant="standard"
              fullWidth
              onChange={(e: React.ChangeEvent<HTMLInputElement>): void => setUserName(e.target.value)}
              onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>): void => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  passwordRef.current?.focus();
                }
              }}
              placeholder="Felhasználónév"
              inputProps={{ style: LoginPageStyles.inputStyle }}
              style={LoginPageStyles.textfieldStyle}
            />
            <TextField
              variant="standard"
              type="password"
              fullWidth
              inputRef={passwordRef}
              onChange={(e: React.ChangeEvent<HTMLInputElement>): void => setPassword(e.target.value)}
              onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>): void => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  void handleSubmit();
                }
              }}
              placeholder="Jelszó"
              inputProps={{ style: LoginPageStyles.inputStyle }}
              style={LoginPageStyles.textfieldStyle}
            />

            <Button
              variant="contained"
              fullWidth
              onClick={(): void => {
                void handleSubmit();
              }}
              style={LoginPageStyles.buttonStyle}
            >
              Bejelentkezés
            </Button>
          </Grid>
          <Grid item sm={6} xs={0} style={LoginPageStyles.imageGrid}>
            <Box display={{ xs: "none", sm: "flex" }} overflow="hidden">
              <img src={Q92} alt="Q92 terminál" style={LoginPageStyles.coverImage} />
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default LoginPage;
